import React, { useState, useCallback } from 'react';

import styles from './RankListFourRow.module.less';
import Header from '../Header';
import GameLink from '../GameLink';
import Icon from '../Icon';
import Button from '../Button';

export default ({ title, operate, to, tag: source, data = [] }) => {
  const [startIndex, setStartIndex] = useState(0);

  const change = useCallback(() => {
    setStartIndex(startIndex => {
      return (startIndex + 12) % data.length;
    });
  }, [data]);

  let showData = data;
  if (data.length > 12) {
    showData = data.slice(startIndex, startIndex + 12);
    if (showData.length < 12) {
      showData = [...showData, ...data.slice(0, 12 - showData.length)];
    }
  }

  return (
    <div className={styles.RankListFourRow}>
      <Header
        title={title}
        operate={operate === '1' && data.length <= 12 ? '0' : operate}
        to={to}
        source={source}
        change={change}
      />
      <nav>
        {
          showData
            .map((app, index) => {
              let id = app.softID || ''
              if (app.androidType === '1') {
                id = app.packageName
              }

              return (
                <GameLink
                  key={index}
                  info={{
                    targetType: '1',
                    appInfo: app,
                  }}
                  source={source}
                  logInfo={{
                    category: 'C',
                    action: 'Game_Non_Button',
                    params: {
                      id,
                      type: 'soft',
                      source,
                    },
                    bizInfo: app.bizInfo,
                  }}>
                  <Icon className="icon" app={app} />
                  <h1 title={app.softName}>{app.softName}</h1>
                  <p>{app.introduction}</p>
                  <Button
                    soft={app}
                    className="action btn"
                    logInfo={{source}} />
                </GameLink>
              )
            })
        }
      </nav>
    </div>
  );
};
